// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--HwqyP","title":"a10a3f92e9--title--W0PI2","item":"a10a3f92e9--item--lRh6S","icon":"a10a3f92e9--icon--pmXuz"};